/**
 * Converte um caractere do CNPJ para seu valor numérico usado no cálculo dos dígitos verificadores.
 * Dígitos '0'–'9' valem 0–9; letras 'A'–'Z' usam ASCII - 48 conforme Receita Federal.
 */
const cnpjCharToValue = (c: string): number => {
  return c.charCodeAt(0) - 48;
};

export const isValidCNPJ = (cnpj: string): boolean => {
  const cleaned = cnpj.replace(/[.\-/\s]/g, '').toUpperCase();

  if (!/^[A-Z0-9]{12}\d{2}$/.test(cleaned)) return false;

  if (/^(.)\1+$/.test(cleaned)) return false;

  let sum = 0;
  let weight = 5;
  for (let i = 0; i < 12; i++) {
    sum += cnpjCharToValue(cleaned.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  let checkDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(cleaned.charAt(12), 10) !== checkDigit) return false;

  sum = 0;
  weight = 6;
  for (let i = 0; i < 13; i++) {
    sum += cnpjCharToValue(cleaned.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  checkDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(cleaned.charAt(13), 10) !== checkDigit) return false;

  return true;
};

export const isValidCPF = (cpf: string): boolean => {
  const cleaned = cpf.replace(/\D/g, '');

  if (cleaned.length !== 11) return false;

  if (/^(\d)\1+$/.test(cleaned)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned.charAt(i)) * (10 - i);
  }
  let checkDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(cleaned.charAt(9)) !== checkDigit) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleaned.charAt(i)) * (11 - i);
  }
  checkDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(cleaned.charAt(10)) !== checkDigit) return false;

  return true;
};
